import React from 'react'

const NavigationSingle = props => (
  <div className={`navigation-single${props.isActive ? ' active' : ''}`}>
    {props.children}
  </div>
)

export default NavigationSingle
